import { Get } from 'config/apiServiceConfig'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

type GetFeatureFlagResponseType = {
  data: {
    active: boolean
  }
}

type GetFeatureFlagKongResponseType = {
  data: {
    hub_feature_flags: {
      key: string
      active: boolean
    }[]
  }
}

export const getFeatureFlag = (locationId: number, featureFlag: string) =>
  Get<GetFeatureFlagResponseType>({
    url: `/api/feature-flag/${locationId}/1/${featureFlag}`,
  })

export const getFeatureFlagKong = async (locationId: number) =>
  axiosInstanceApiGateway.Get<GetFeatureFlagKongResponseType, true>({
    url: `/accounts/internal/v1/hub-feature/device/location`,
    params: {
      feature_flag_device: 1,
      location_id: locationId,
    },
  })
